<script setup lang="ts">
import HeaderBackButton from "@/core/components/header-back-button/HeaderBackButton.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import {onMounted, ref} from "vue";
import type {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import {notificationTemplateApi} from "@/container";
import {useCommunicationStore} from "@/communication/stores/communication.store";
import {useRouter} from "vue-router";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import NotificationTemplate from "@/notification-template/components/NotificationTemplate.vue";

const {mode, programId} = useCommunicationStore();
const templates = ref<INotificationTemplate[]>([]);
const loading = ref(false);
const communicationStore = useCommunicationStore();
const router = useRouter();

onMounted(() => {
    loading.value = true;
    notificationTemplateApi()
        .index({program_id: programId, type: mode})
        .then(response => templates.value = response)
        .finally(() => loading.value = false);
});

/**
 * On message selected.
 */
const onSelected = (template: INotificationTemplate) => {
    communicationStore.template = template;
    router.push({
        name: 'patient-administration.communication.summary'
    });
};
</script>

<template>
  <div>
    <HeaderBackButton title="Communication par notification" />
    <BaseCard class="m-4 p-4 space-y-8">
      <h2>Sélectionner le message</h2>
      <BaseFlexSpinner v-if="loading" />
      <NotificationTemplate
        v-for="template in templates" :key="template.id"
        :template="template"
        selectable
        @selected="_template => onSelected(_template)"
      />
    </BaseCard>
  </div>
</template>
